
import { FaArrowRight } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import YouTubeEmbed from '../../utils/youtubeEmbed';
const Rent = ({ training }) => {


    const videoUrl = training?.thumbnailYoutubeURL
    const title = training?.title1
    const description = training?.description1
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 place-items-start">
            <div className="w-full max-w-5xl h-[20rem]  2xl:max-w-7xl 2xl:h-[25rem] overflow-hidden  bg-gray-200">
                {/* <iframe className="max-w-full w-full h-full " src={videoUrl} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe> */}
                <YouTubeEmbed videoUrl={videoUrl} />
            </div>
            <div className='flex flex-col gap-5'>
                <h1 className="text-4xl font-bold ">{title}</h1>
                <p className="w-auto  text-justify text-sky-900  text-base font-normal leading-normal">{description}</p>
                <Link to={"/training-services/rental-facilities"} className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 flex w-fit h-fit">
                    <span className="text-white text-base font-bold capitalize flex items-center gap-3">more info <FaArrowRight /></span>
                </Link>
            </div>

        </div>
    )
}
Rent.propTypes = {
    training: PropTypes.object
}
export default Rent